
import { useTranslation } from "react-i18next";

import DynamicForms from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import FormTextBox from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";

import EColourPanel from "../../../interfaces/EColourPanel";
import { IDialogChildComponent } from "../../../reducers/dialog";
import { IOrderLocationsGroup } from "../state/venueAreas.reducer";
import { addVenueArea, updateVenueArea } from "../state";

interface INewArea extends IDialogChildComponent {
  group: IOrderLocationsGroup;
  dispatch: any;
  venueId:string;
  venue_group_id:string;
}

function NewAreaDialog(props:INewArea) {
  const { t } = useTranslation();
  const { onClose, onDialogClose , group, dispatch, venueId, venue_group_id} = props;


    //create or edit venue area
    function onSubmit(data:any) {
      if(group?.id){
        dispatch(updateVenueArea({
          ...group,
          name_public:data.name_public,
        }))
      }else{
        dispatch(addVenueArea({
          name_public:data.name_public,
          ...( venue_group_id ? {venue_group_id:venue_group_id} : {venue_id: venueId })
      }))
      }
      if(onDialogClose){
        onDialogClose();
      }else{
        onClose(); 
      }
      
  }

  return (
    <DynamicForms
        formKeyName={"new-venue-area-form"}
        formRows={ [
          {
              label: "forms.settings.venueAreaName",
              keyName: "name_public",
              gridColumnOptions: { formCol: 12 },
              Component: FormTextBox,
              registerOptions: {
                  required: true,
              },
              inputProperties: { required: true },
          }
      ]}
        onHandleSubmit={onSubmit}
        formData={group}
        isDialog={true}
        // hasDataChanged={hasFormChanged}
        formButtons={{
            leftButton: {
                label: t('misc.cancel'), type: "button", onClick: onClose,
                color: EColourPanel.DEFAULT
            },
            rightButton: {
                type: 'submit', label: group?.id ? t('forms.settings.buttonEditVenueArea') : t('forms.settings.buttonCreateVenueArea'),
                color: EColourPanel.PRIMARY
            }
        }
        }
    />
  )
}

export default NewAreaDialog;
